import { useRecoilValue } from 'recoil';

import { useGetCommunityUserQuery } from '@/hooks/community/mobile/community.gql.impl';
import { tokenState } from '@/recoil/atoms/common/auth';
import { GetCommunityUserQuery } from '@/types/bff/gql-schema';
import { CommunityUser } from '@/types/community';
import dayjs from 'dayjs';

const parseCommunityUser = (data: GetCommunityUserQuery): CommunityUser => {
  return {
    ...data,
    nickname: data.communityUser.nickname,
    userId: data.communityUser.userId,
    tutorialCompleted: data.communityUser.tutorialCompleted,
    profileImageUrl: data.communityUser.profileImageUrl,
    isAdmin: data.communityUser.isAdmin,
    bannedUntil: data.communityUser.bannedUntil ?? undefined,
    formattedBannedDate: data.communityUser.bannedUntil
      ? dayjs(data.communityUser.bannedUntil).format('YYYY년 MM월 DD일 HH시까지')
      : undefined,
    isBanned: dayjs().isBefore(data.communityUser.bannedUntil),
  };
};

interface GetCommunityUser {
  userProfileData: CommunityUser | undefined;
  isUserDataLoading: boolean;
  communityUserRefetch: () => void;
}

const useGetCommunityUser = (): GetCommunityUser => {
  const token = useRecoilValue(tokenState);
  const {
    data: userProfileData,
    refetch: communityUserRefetch,
    isLoading: isUserDataLoading,
  } = useGetCommunityUserQuery(
    {},
    {
      enabled: !!token,
      select: (data) => parseCommunityUser(data),
      refetchOnWindowFocus: true,
    }
  );

  return {
    userProfileData,
    isUserDataLoading,
    communityUserRefetch,
  };
};

export default useGetCommunityUser;
